<template>
  <!-- this has been replaced by edit-in-place component -->
  <div class="text-field-wrapper">
      <div class="saving-msg" v-if="isSaving"><span class="fa fa-cog fa-spin fa-1x"></span></div>
      <div class="saving-msg" v-if="isSaved"><span class="fa fa-cog fa-1x"></span></div>
      <input class="text-field-input"
             type="text"
             ref="inputField"
             v-if="!readOnly"
             :placeholder="placeHolder"
             v-model="myValue"
             @blur="editingComplete"
             @keyup.enter="handleEnterPressed">
      <input class="text-field-input"
             type="text"
             disabled
             v-else
             :placeholder="placeHolder"
             v-model="myValue"
             >

  </div>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'text-field',
    props: {
        value: String,
        placeHolder: {
            type: String,
            default: '',
        },
        readOnly: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            myValue: this.value,
            isSaved: false,
            isSaving: false,
        }
    },
    watch: {
        value(newValue) {
            this.myValue = newValue;
        }
    },
    methods: {
        handleEnterPressed() {
            this.$refs.inputField.blur();
        },
        editingComplete() {
            if (this.value != this.myValue) {
                this.isSaving = true;
                this.saveChange();
            }
        },
        saveChange() {
            this.$emit('fieldChange', this.myValue);
        },
        saveComplete() {
            this.isSaving = false;
            this.isSaved = false;
            // window.setTimeout(()=>{
            //     this.isSaved = false;
            // }, 200);

            //updating props throws a Vue warning - but this needs to be done.
            Vue.config.silent = true;
            this.value = this.myValue;
            Vue.config.silent = false;

        }
    },
    computed: {
    },
}
</script>

<style>
.text-field-wrapper {
    height: 38px;
    width: 100%;
    position: relative;
    overflow: hidden;
    margin: 0 4px 4px 0;
}
.text-field-input {
    height: 100%;
    width: 100%;
    border: 1px solid #DBDBDB;
    border-radius: 2px;
    padding-left: 5px;
}
.read-only {
    display: flex;
    padding-left: 2px;
    align-items: center;
    background-color: silver;
}
.saving-msg {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
}

</style>